export default __webpack_public_path__ + "static/media/icon-twitter-2.855af881.svg";